import React from 'react';
import styles from './Hero.module.css';

const Hero: React.FC = () => (
  <div className={styles.heroTile}>
    <div className={styles.mlabel}>
      <span>▦ Oak Cliff · Dallas, TX</span>
      <span className={styles.mno}>00</span>
    </div>
    <h1 className={styles.wordmark}>
      OAKCLIFF<span className={styles.dot}>.</span>TECH
    </h1>
    <p className={styles.tagline}>
      Building the future of technology in Oak&nbsp;Cliff, Texas.
    </p>
  </div>
);

export default Hero;
